exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a[data-v-5de381cb]{fill:#fff}.margin[data-v-5de381cb]{margin-left:10px;margin-right:auto}.delay[data-v-5de381cb]{animation-delay:.2s}.faster[data-v-5de381cb]{animation-duration:.2s}.fast[data-v-5de381cb]{animation-duration:.15s}@keyframes slideInRight-data-v-5de381cb{0%{transform:translate3d(100%,0,0);visibility:hidden}to{transform:translateZ(0);visibility:visible}}._slideInRight[data-v-5de381cb]{animation-name:slideInRight-data-v-5de381cb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5de381cb","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/categories/CategoriesList.vue
// module id = 451
// module chunks = 187